import Type from "@/model/types/Type";

const type = {
    WEB: 1,
    MOBILE: 2,
}

const list = [
    {
        value: type.WEB,
        text: "Web",
    },
    {
        value: type.MOBILE,
        text: "Mobile",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}